module.exports = __webpack_public_path__ + "img/screenshot_quiz@2x.ce1cd47d.png";